import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { MapTrifold } from "@phosphor-icons/react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#FFF1E5]" data-testid="not-found-page">
      <title>Page Not Found | Farmwatch</title>
      <Header />
      <main className="max-w-[600px] mx-auto px-4 py-24 text-center">
        <MapTrifold size={56} className="text-[#0F766E] mx-auto mb-6" weight="duotone" />
        <h1 className="font-serif text-4xl text-[#33302E] mb-3">Page not found</h1>
        <p className="text-[#6B6661] mb-8">
          This page doesn't exist or has been retired. The markets, news and marketplace are all still here.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" data-testid="notfound-home-link" className="px-6 py-3 bg-[#0F766E] text-white text-sm font-semibold hover:bg-[#0D6B64] transition-colors">Back to Farmwatch</Link>
          <Link to="/todays-mart-prices" data-testid="notfound-marts-link" className="px-6 py-3 border-2 border-[#0F766E] text-[#0F766E] text-sm font-semibold hover:bg-[#0F766E] hover:text-white transition-colors">Today's Mart Prices</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
